var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValues(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9854",
    "data-name": "Group 9854",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5525",
    "data-name": "Rectangle 5525",
    width: 512,
    height: 512,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10010",
    "data-name": "Group 10010",
    transform: "translate(18898.004 8932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6794",
    "data-name": "Path 6794",
    d: "M50.7,76.888H218.37c-27.9,57.245-55.541,113.952-83.83,171.984C106.3,190.946,78.663,134.245,50.7,76.888",
    transform: "translate(-18776.461 -8715.872)",
    fill: "#0071af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6795",
    "data-name": "Path 6795",
    d: "M219.647,138.342H50.426c.614-1.99,1.03-3.737,1.677-5.395,11.38-29.181,22.868-58.32,34.084-87.561,1.507-3.929,3.392-5.292,7.6-5.263,27.694.186,55.387.115,83.081.067,3.062,0,5.331.234,6.711,3.808,11.776,30.582,23.77,61.081,35.671,91.612a13.592,13.592,0,0,1,.4,2.733",
    transform: "translate(-18777.064 -8796.745)",
    fill: "#4295c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6796",
    "data-name": "Path 6796",
    d: "M140.906,40.752c-2.8,7.151-5.4,13.829-8.01,20.513q-14.156,36.284-28.254,72.584c-1.107,2.864-2.01,4.886-5.875,4.857-26.446-.2-52.9-.115-79.346-.141a13.218,13.218,0,0,1-2.285-.528c1.238-1.933,2.208-3.641,3.367-5.212,20.721-28.074,41.534-56.08,62.136-84.243,4.154-5.676,9.235-8.5,16.218-8.437,12.4.109,24.794.016,37.188.051a48.814,48.814,0,0,1,4.861.557",
    transform: "translate(-18850.305 -8796.697)",
    fill: "#4295c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6797",
    "data-name": "Path 6797",
    d: "M222.2,138.354H171.112c-10.333,0-20.663-.093-30.993.058-3.043.042-4.752-.672-5.965-3.814-11.623-30.182-23.447-60.288-35.175-90.428a24.661,24.661,0,0,1-.794-3.836c15.376,0,30.414-.272,45.422.227,3.05.1,6.954,2.393,8.855,4.9,23.089,30.384,45.873,61,69.743,92.9",
    transform: "translate(-18671.979 -8796.446)",
    fill: "#4295c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6798",
    "data-name": "Path 6798",
    d: "M87.444,223.812c.778-1.808,1.485-3.654,2.346-5.42q33.015-67.8,65.954-135.639c2.218-4.595,4.867-6.047,9.856-5.987,22.51.272,45.022.118,67.535.118h8.035C189.3,126.892,138.761,175.613,88.218,224.334c-.256-.173-.515-.349-.774-.522",
    transform: "translate(-18695.619 -8716.145)",
    fill: "#0071af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6799",
    "data-name": "Path 6799",
    d: "M171.985,224.944C120.694,175.5,70.187,126.808,18.329,76.817H32.941c20.884,0,41.768-.109,62.648.16,2.3.029,5.767,1.641,6.688,3.51Q137.189,151.26,171.6,222.279a15.866,15.866,0,0,1,.384,2.665",
    transform: "translate(-18847.68 -8716.081)",
    fill: "#0071af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6800",
    "data-name": "Path 6800",
    d: "M93.434,30.963c0,6.809.115,13.618-.035,20.423-.15,6.633-3.779,10.559-9.5,10.68-6.035.131-9.93-3.878-9.994-10.8q-.192-20.11-.01-40.226C73.948,4.121,77.8-.032,83.7,0s9.594,4.185,9.716,11.16c.115,6.6.026,13.2.022,19.8",
    transform: "translate(-18725.621 -8885)",
    fill: "#f5f5f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6801",
    "data-name": "Path 6801",
    d: "M56.982,66.669c-.131,8.642-7.45,13.554-13.792,10.152C29.928,69.708,16.952,62.048,4.052,54.292c-4.285-2.579-5.149-8.485-2.7-12.626,2.566-4.335,7.677-6.239,12.3-3.686,13,7.174,25.9,14.539,38.564,22.27,2.477,1.513,3.754,5,4.765,6.418",
    transform: "translate(-18888.002 -8803.987)",
    fill: "#f5f5f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6802",
    "data-name": "Path 6802",
    d: "M192.766,48.8c-1.066,1.289-2.7,4.62-5.37,6.252-11.959,7.308-24.148,14.248-36.388,21.082-5.584,3.116-11.258,1.414-13.869-3.6-2.477-4.758-.87-10.079,4.41-13.186,12.08-7.113,24.189-14.194,36.449-20.993,7.287-4.041,15.053.528,14.768,10.444",
    transform: "translate(-18588.779 -8803.863)",
    fill: "#f5f5f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6803",
    "data-name": "Path 6803",
    d: "M149.709,17.549c-1.52,3.6-2.2,5.772-3.3,7.7q-9.643,16.9-19.469,33.705c-4.074,6.953-9.347,8.857-14.7,5.516-5.05-3.152-5.811-8.5-2-15.169,6.643-11.618,13.293-23.236,20.1-34.761,2.522-4.268,6.515-7.1,11.331-4.665,3.245,1.638,5.527,5.18,8.039,7.67",
    transform: "translate(-18650.742 -8865.247)",
    fill: "#f5f5f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6804",
    "data-name": "Path 6804",
    d: "M44.513,9.01c1.507,1.155,5.018,2.656,6.653,5.311,7.443,12.1,14.484,24.448,21.409,36.857,2.966,5.315,1.363,10.728-3.306,13.426-4.72,2.723-10.119,1.449-13.293-3.856-7.4-12.37-14.682-24.816-21.594-37.461C30.835,16.8,35.6,9.138,44.513,9.01",
    transform: "translate(-18814.943 -8865.181)",
    fill: "#f5f5f6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValues);
export default __webpack_public_path__ + "static/media/Values.0526100cb296300447937375165363c4.svg";
export { ForwardRef as ReactComponent };